// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import OnBoarding from '../../on-boarding/components/OnBoarding';
import {actions as OnBoardingAction} from '../../on-boarding/duck';
import {actions as GeneralAction} from '../../configure/general/duck';
import {actions as AccountAction} from '../../profile/account/duck';
import {actions as CurrencyAction} from '../../currency/duck';
import {actions as CountryAction} from '../../country/duck';

import type {RootState} from '../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    user: state.auth.user,
    initialAuthDone: state.auth.initialAuthDone,
    isSaving: state.currency.isSaving,
    countries: state.country.countries,
    isFetchingCountries: state.country.isFetchingCountries,
    currency: state.currency.currency,
    currencies: state.currency.currencies,
    isFetchingCurrencies: state.currency.isFetching,
    isFetchingCurrency: state.currency.isFetchingCurrency,
    country: state.currency.country,
    store: state.store.store,
    contact: state.information.contact,
    isFetchingContact: state.information.isFetchingContact,
    contactTypes: state.information.contactTypes,
    information: state.ui.storeInformation,
    isFetchingInformation: state.ui.isFetchingStoreInformation,
    validationResult: state.onBoarding.validationResult,
    isValidating: state.onBoarding.isValidating,
    isSettingConfig: state.onBoarding.isSettingConfig,
    resellerInformation: state.ui.resellerInformation,
    isFetchingResellerInformation: state.ui.isFetchingResellerInformation,
    isSavingCanalInf: state.onBoarding.isSavingCanalInf,
    saveCanalInfSuccess: state.onBoarding.saveCanalInfSuccess,
    isSavingOnboardingInf: state.onBoarding.isSavingOnboardingInf,
    saveOnboardingInfSuccess: state.onBoarding.saveOnboardingInfSuccess,
    initialConfigSaved: state.onBoarding.initialConfigSaved,
    errorOnboarding: state.onBoarding.errorOnboarding,
    error: state.onBoarding.error,
    storeTypes: state.onBoarding.storeTypes,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...OnBoardingAction,
        ...GeneralAction,
        ...CurrencyAction,
        ...CountryAction,
        ...AccountAction,
      },
      dispatch
    )
)(OnBoarding);
